import { render } from "./twoColumnTemplate.vue?vue&type=template&id=74f231a9&scoped=true"
import script from "./twoColumnTemplate.vue?vue&type=script&lang=js"
export * from "./twoColumnTemplate.vue?vue&type=script&lang=js"

import "./twoColumnTemplate.vue?vue&type=style&index=0&id=74f231a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f231a9"]])

export default __exports__